import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import QRCodeModal from '@walletconnect/qrcode-modal';
import WalletConnectClient from '@walletconnect/sign-client';
import { getSdkError } from '@walletconnect/utils';
import { ClientNotInitializedError, QRCodeModalError } from './errors.js';
export var WalletConnectChainID;

(function (WalletConnectChainID) {
  WalletConnectChainID["Mainnet"] = "tron:0x2b6653dc";
  WalletConnectChainID["Shasta"] = "tron:0x94a9059e";
  WalletConnectChainID["Nile"] = "tron:0xcd8690dc";
})(WalletConnectChainID || (WalletConnectChainID = {}));

export var WalletConnectMethods;

(function (WalletConnectMethods) {
  WalletConnectMethods["signTransaction"] = "tron_signTransaction";
  WalletConnectMethods["signMessage"] = "tron_signMessage";
})(WalletConnectMethods || (WalletConnectMethods = {}));

var getConnectParams = function getConnectParams(chainId, pairingTopic) {
  return {
    requiredNamespaces: {
      tron: {
        chains: [chainId],
        methods: [WalletConnectMethods.signTransaction, WalletConnectMethods.signMessage],
        events: []
      }
    },
    pairingTopic: pairingTopic
  };
};

export var WalletConnectWallet = /*#__PURE__*/function () {
  function WalletConnectWallet(config) {
    _classCallCheck(this, WalletConnectWallet);

    this._options = config.options;
    this._network = config.network;
    this._qrcodeModalOptions = config.qrcodeModalOptions;
  }

  _createClass(WalletConnectWallet, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$_client,
            _this = this;

        var client, sessions, accounts, _yield$client$connect, uri, approval;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!((_this$_client = this._client) !== null && _this$_client !== void 0)) {
                  _context.next = 4;
                  break;
                }

                _context.t0 = _this$_client;
                _context.next = 7;
                break;

              case 4:
                _context.next = 6;
                return WalletConnectClient.init(this._options);

              case 6:
                _context.t0 = _context.sent;

              case 7:
                client = _context.t0;
                sessions = client.find(getConnectParams(this._network)).filter(function (s) {
                  return s.acknowledged;
                });

                if (!sessions.length) {
                  _context.next = 18;
                  break;
                }

                // select last matching session
                this._session = sessions[sessions.length - 1]; // We assign this variable only after we're sure we've received approval

                this._client = client;
                this._client = client;
                accounts = Object.values(this._session.namespaces).map(function (namespace) {
                  return namespace.accounts;
                }).flat();
                this.address = accounts[0].split(':')[2];
                return _context.abrupt("return", {
                  address: this.address
                });

              case 18:
                _context.next = 20;
                return client.connect(getConnectParams(this._network));

              case 20:
                _yield$client$connect = _context.sent;
                uri = _yield$client$connect.uri;
                approval = _yield$client$connect.approval;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  if (uri) {
                    QRCodeModal.open(uri, function () {
                      reject(new QRCodeModalError());
                    }, _this._qrcodeModalOptions);
                  }

                  approval().then(function (session) {
                    _this._session = session; // We assign this variable only after we're sure we've received approval

                    _this._client = client;
                    var accounts = Object.values(_this._session.namespaces).map(function (namespace) {
                      return namespace.accounts;
                    }).flat();
                    _this.address = accounts[0].split(':')[2];
                    resolve({
                      address: _this.address
                    });
                  }).catch(reject).finally(function () {
                    QRCodeModal.close();
                  });
                }));

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._client && this._session)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return this._client.disconnect({
                  topic: this._session.topic,
                  reason: getSdkError('USER_DISCONNECTED')
                });

              case 3:
                this._session = undefined;
                _context2.next = 7;
                break;

              case 6:
                throw new ClientNotInitializedError();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "client",
    get: function get() {
      if (this._client) {
        return Object.assign({}, this._client, {
          off: this._client.removeListener
        });
      } else {
        throw new ClientNotInitializedError();
      }
    }
  }, {
    key: "checkConnectStatus",
    value: function () {
      var _checkConnectStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$_client2;

        var client, sessions, accounts;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!((_this$_client2 = this._client) !== null && _this$_client2 !== void 0)) {
                  _context3.next = 4;
                  break;
                }

                _context3.t0 = _this$_client2;
                _context3.next = 7;
                break;

              case 4:
                _context3.next = 6;
                return WalletConnectClient.init(this._options);

              case 6:
                _context3.t0 = _context3.sent;

              case 7:
                client = _context3.t0;
                sessions = client.find(getConnectParams(this._network)).filter(function (s) {
                  return s.acknowledged;
                });

                if (!sessions.length) {
                  _context3.next = 17;
                  break;
                }

                // select last matching session
                this._session = sessions[sessions.length - 1]; // We assign this variable only after we're sure we've received approval

                this._client = client;
                accounts = Object.values(this._session.namespaces).map(function (namespace) {
                  return namespace.accounts;
                }).flat();
                this.address = accounts[0].split(':')[2];
                return _context3.abrupt("return", {
                  address: this.address
                });

              case 17:
                return _context3.abrupt("return", {
                  address: ''
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkConnectStatus() {
        return _checkConnectStatus.apply(this, arguments);
      }

      return checkConnectStatus;
    }()
  }, {
    key: "signTransaction",
    value: function () {
      var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(transaction) {
        var _yield$this$_client$r, result;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this._client && this._session)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 3;
                return this._client.request({
                  chainId: this._network,
                  topic: this._session.topic,
                  request: {
                    method: WalletConnectMethods.signTransaction,
                    params: {
                      address: this.address,
                      transaction: _objectSpread({}, transaction)
                    }
                  }
                });

              case 3:
                _yield$this$_client$r = _context4.sent;
                result = _yield$this$_client$r.result;
                return _context4.abrupt("return", result);

              case 8:
                throw new ClientNotInitializedError();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function signTransaction(_x) {
        return _signTransaction.apply(this, arguments);
      }

      return signTransaction;
    }()
  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(message) {
        var _yield$this$_client$r2, signature;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this._client && this._session)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 3;
                return this._client.request({
                  chainId: this._network,
                  topic: this._session.topic,
                  request: {
                    method: WalletConnectMethods.signMessage,
                    params: {
                      address: this.address,
                      message: message
                    }
                  }
                });

              case 3:
                _yield$this$_client$r2 = _context5.sent;
                signature = _yield$this$_client$r2.signature;
                return _context5.abrupt("return", signature);

              case 8:
                throw new ClientNotInitializedError();

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function signMessage(_x2) {
        return _signMessage.apply(this, arguments);
      }

      return signMessage;
    }()
  }]);

  return WalletConnectWallet;
}();